import jwtDecode from 'jwt-decode';
export const getUserId = () => {
    const token = localStorage.getItem('authToken');
    try {
        if (token) {
            const decoded = jwtDecode(token);
            return decoded.user_id;
        }
        throw Error('authToken not found');
    }
    catch (error) {
        return null;
    }
};
export const checkAuthorization = () => {
    const token = localStorage.getItem('authToken');
    try {
        if (token) {
            const decoded = jwtDecode(token);
            const expirationTime = new Date(decoded.exp * 1000);
            if (expirationTime < new Date()) {
                throw new Error('Try logging in again');
            }
            return {
                status: 'ok',
                data: {
                    userId: decoded.user_id,
                    role: decoded.role,
                    onboardingStatus: decoded.onboarding_status
                },
                error: undefined
            };
        }
        throw Error();
    }
    catch (error) {
        return { status: 'error', data: null, error: error.message };
    }
};
//# sourceMappingURL=authHelpers.js.map